import styled, { css } from 'styled-components';

import { Spacer, Flexer } from '@ontruck/orc';

const rowStyles = ({ noBorder = false, rowHeight, showBackground = true }) => css`
  width: 100%;
  background: var(--white);
  ${rowHeight && `height: ${rowHeight}px;`}
  ${!noBorder && `border-bottom: 1px solid var(--greyMouse);`}
`;

const StyledRow = styled(Spacer).attrs(({ noPadding }) => ({
  pTop: !noPadding && 'XS',
  pBottom: !noPadding && 'XS',
  pLeft: !noPadding && 'S',
  pRight: !noPadding && 'S',
}))`
  ${rowStyles};
`;

const StyledRowFlex = styled(Flexer.Parent).attrs(({ noPadding }) => ({
  pTop: !noPadding && 'XS',
  pBottom: !noPadding && 'XS',
  pLeft: !noPadding && 'S',
  pRight: !noPadding && 'S',
}))`
  ${rowStyles};
`;

export default StyledRow;
export { StyledRowFlex };
